import { Card, type CardProps } from '@mantine/core'

const ACCENT_COLORS = {
  primary: '#098d93',
  info: '#49b6d6',
  success: '#2f9e44',
  warning: '#f59c1a',
  danger: '#ff5b57',
  none: 'transparent',
} as const

interface WidgetCardProps extends CardProps {
  accent?: keyof typeof ACCENT_COLORS
  children: React.ReactNode
  onClick?: React.MouseEventHandler<HTMLDivElement>
  onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>
  role?: string
  tabIndex?: number
  'aria-pressed'?: boolean | 'true' | 'false'
}

/** Pinta as bordas no hover SEM tocar na de cima quando ela carrega a faixa do
 *  accent — `style.borderColor` e atalho das quatro e apagava a faixa. */
function pintarBordas(el: HTMLElement, cor: string, accentColor: string) {
  el.style.borderLeftColor = cor
  el.style.borderRightColor = cor
  el.style.borderBottomColor = cor
  if (accentColor === 'transparent') el.style.borderTopColor = cor
}

export function WidgetCard({ accent = 'none', children, style, ...rest }: WidgetCardProps) {
  const accentColor = ACCENT_COLORS[accent]
  return (
    <Card
      radius="md"
      withBorder
      {...rest}
      style={{
        borderColor: 'var(--ai-border-light)',
        borderTop: accentColor !== 'transparent'
          ? `3px solid ${accentColor}`
          : undefined,
        boxShadow: 'none',
        transition: 'border-color var(--ai-transition-base)',
        ...style,
      }}
      onMouseEnter={(e) => pintarBordas(e.currentTarget, 'var(--ai-border-medium)', accentColor)}
      onMouseLeave={(e) => pintarBordas(e.currentTarget, 'var(--ai-border-light)', accentColor)}
    >
      {children}
    </Card>
  )
}
